












import { Component, Prop, Vue } from 'vue-property-decorator';
import { MentoringCardWrapper } from '../components';
import MentoringProgramCard from '../programcard';
import { IMentoringProgramsList, Programs, PopupData } from './types';

@Component({
  components: {
    MentoringCardWrapper,
    MentoringProgramCard,
  },
})
export default class MentoringProgramsList extends Vue
  implements IMentoringProgramsList {
  @Prop({ type: Array, default: () => [] })
  readonly items!: Programs;

  @Prop({ type: Number, default: 2 })
  readonly step!: number;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/modules/mentoring/programslist/MentoringProgramsList.vue